const MELBOURNE_TZ = 'Australia/Melbourne';

const monthFormatter = new Intl.DateTimeFormat('en-AU', {
  timeZone: MELBOURNE_TZ,
  month: 'long',
});

const yearFormatter = new Intl.DateTimeFormat('en-AU', {
  timeZone: MELBOURNE_TZ,
  year: 'numeric',
});

const melbourneDateKey = (date: Date): string =>
  date.toLocaleDateString('en-CA', { timeZone: MELBOURNE_TZ });

const daysBetweenMelbourneDates = (from: Date, to: Date): number => {
  const fromKey = melbourneDateKey(from);
  const toKey = melbourneDateKey(to);
  const fromMs = Date.parse(`${fromKey}T00:00:00Z`);
  const toMs = Date.parse(`${toKey}T00:00:00Z`);
  return Math.round((toMs - fromMs) / 86_400_000);
};

export const formatPostedDate = (
  postedAt: string,
  now: Date = new Date(),
): string => {
  const posted = new Date(postedAt);
  const daysAgo = daysBetweenMelbourneDates(posted, now);

  if (daysAgo <= 0) {
    return 'today';
  }
  if (daysAgo === 1) {
    return 'yesterday';
  }
  if (daysAgo <= 30) {
    return `${daysAgo} days ago`;
  }

  const postedYear = yearFormatter.format(posted);
  const nowYear = yearFormatter.format(now);
  const month = monthFormatter.format(posted);

  if (postedYear === nowYear) {
    return month;
  }

  return `${month} ${postedYear}`;
};
